module.exports = __webpack_public_path__ + "img/09.bfe245a4.jpg";